import 'whatwg-fetch';
import { middle_dev, middle_key_val } from 'config';
import { couponsWeb_controller } from 'config';

const authHeader = new Headers();
authHeader.append('Accept', 'application/json');
authHeader.append('Content-Type', 'application/json');

export default class BonusService{
    static consulting(payload = {}) {
        /*
        *   @consultingData
        *   Consulta los datos del usuario en bonus a partir del documento de identidad y la fecha de nacimiento
        *   
        *   IN      |   tipoDocumento (1|2|3)           |   numeric
        *   IN      |   numDocumento                    |   string
        *   IN      |   fechaNacimiento (yyyy-mm-dd)    |   string
        *   OUT     |   data[payload]                   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${couponsWeb_controller}/consultarBonus`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static linking(payload = {}) {
        /*
        *   @linkingData
        *   Vincula el documento de un usuario a bonus
        *   
        *   IN      |   personaCodigo                   |   string
        *   IN      |   fechaNacimiento (yyyy-mm-dd)    |   string
        *   OUT     |   data[payload]                   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/vincularBonus`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
}